import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  IconButton,
  CircularProgress
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import { toast } from 'react-toastify';
import { OffersAPI } from 'api_inbusiness';
import styles from './DeleteOfferModal.module.scss';

const DeleteOfferModal = ({ open, onClose, onSuccess, offer }) => {
  const [loading, setLoading] = useState(false);

  const handleDelete = async () => {
    if (!offer) return;
    
    setLoading(true);
    const res = await OffersAPI.delete(offer.id);
    setLoading(false);

    if (res.ok) {
      toast.success('Oferta a fost ștearsă cu succes!');
      onSuccess?.();
    } else {
      toast.error(res.error || 'Eroare la ștergerea ofertei');
    }
  };

  if (!offer) return null;

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="xs"
      fullWidth
      PaperProps={{
        className: styles.dialog
      }}
    >
      <DialogTitle className={styles.title}>
        <div className={styles.titleContent}>
          <WarningAmberIcon className={styles.warningIcon} />
          <span>Confirmare Ștergere</span>
        </div>
        <IconButton onClick={onClose} className={styles.closeButton} disabled={loading}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent className={styles.content}>
        <Typography variant="body1" className={styles.message}>
          Ești sigur că vrei să ștergi oferta:
        </Typography>
        <Typography variant="h6" className={styles.offerTitle}>
          "{offer.title}"
        </Typography>
        <Typography variant="body2" className={styles.warning}>
          Această acțiune nu poate fi anulată.
        </Typography>
      </DialogContent>

      <DialogActions className={styles.actions}>
        <Button 
          onClick={onClose} 
          disabled={loading}
          className={styles.cancelButton}
        >
          Anulează
        </Button>
        <Button
          variant="contained"
          onClick={handleDelete}
          disabled={loading}
          className={styles.deleteButton}
        >
          {loading ? <CircularProgress size={20} color="inherit" /> : 'Șterge Oferta'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteOfferModal;
